<template>
  <div class="sm-legend">
    <div
      :class="[isLegendActive ? 'active' : '', 'map-tools__btn legend']"
      @click="toggleLegend"
    >
      <r-icon name="list" :size="14" :active="isLegendActive" />
    </div>

    <div class="sm-legend__content" v-if="isLegendActive">
      <div class="sm-legend-header">
        Легенда
      </div>
      <ul class="sm-legend__list">
        <li class="sm-legend__item">
          <div class="sm-legend__item-key">
            <div class="sm-legend__item-symbol nodes" />
          </div>
          <div class="sm-legend__item-value">
            Узлы
          </div>
        </li>
        <li class="sm-legend__item">
          <div class="sm-legend__item-key">
            <div class="sm-legend__item-symbol links" />
          </div>
          <div class="sm-legend__item-value">
            Отрезки
          </div>
        </li>
        <!-- <li class="sm-legend__item" v-if="!!activeCalc">
          <div class="sm-legend__item-key">
            <div class="sm-legend__item-symbol result" />
          </div>
          <div class="sm-legend__item-value">
            Значение расчета на отрезке
          </div>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["is-legend-active", "mode"],
  computed: {
    activeCalc() {
      return this.$store.state.scenarioModelling.activeCalc;
    }
  },
  methods: {
    toggleLegend() {
      this.$emit("toggle-legend");
    }
  }
};
</script>

<style lang="scss">
.sm-legend {
  &__content {
    position: absolute;
    top: 125px;
    right: 0;
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    background-color: var(--bg_panel_primary) !important;
    border-color: var(--dividers_low_contrast) !important;
    width: 220px;
    z-index: 1000;
    font-size: 11px;
    color: var(--white_white);
    user-select: none;
  }

  &-header {
    padding: 5px 10px;
    font-weight: bold;
    border-radius: var(--border-radius);
    color: var(--text_primary) !important;
    background-color: var(--bg_surface) !important;
  }

  &__list {
    padding: 8px;
  }

  &__item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 5px;
    }

    &-key {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    &-value {
      margin-left: 10px;
      color: var(--text_secondary) !important;
    }

    &-symbol {
      &.nodes {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #3a8fd2;
      }

      &.links {
        width: 100%;
        height: 2px;
        background: #3a8fd2;
      }

      &.result {
        width: 100%;
        height: 12px;
        border: 1px solid rgba(255, 68, 140, 0.8);
        background-color: rgba(255, 68, 140, 0.4);
      }
    }
  }
}
</style>
